"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sample = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var i18n_1 = __importDefault(require("../i18n"));
var api_1 = require("../api");
var util_1 = require("../util");
var sentry_1 = require("../sentry");
var ReadonlyUser_1 = require("./ReadonlyUser");
var Sample = function (_a) {
    var groups = _a.groups;
    var _b = (0, react_1.useState)(), user = _b[0], setUser = _b[1];
    var _c = (0, react_1.useState)(), world = _c[0], setWorld = _c[1];
    var _d = (0, react_1.useState)(true), loading = _d[0], setLoading = _d[1];
    var _e = (0, react_1.useState)(false), worldLoading = _e[0], setWorldLoading = _e[1];
    (0, react_1.useEffect)(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var nextUser, nextWorld;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchUser()];
                    case 1:
                        nextUser = _a.sent();
                        if (nextUser)
                            setUser(nextUser);
                        if (!(nextUser && nextUser.locationInfo.worldId)) return [3 /*break*/, 3];
                        setWorldLoading(true);
                        return [4 /*yield*/, (0, api_1.fetchWorlds)([nextUser.locationInfo.worldId])];
                    case 2:
                        nextWorld = (_a.sent())[0];
                        if (nextWorld) {
                            setWorld(nextWorld);
                            setWorldLoading(false);
                        }
                        _a.label = 3;
                    case 3:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Segment, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Header, { as: "h2", children: i18n_1.default.sampleTitle }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Dimmer.Dimmable, { dimmed: loading, children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dimmer, { active: loading, inverted: true, children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Loader, { children: i18n_1.default.loading }) }), loading ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})) : user ? ((0, jsx_runtime_1.jsx)(SampleUser, { user: injectSample(user), world: world, worldLoading: worldLoading, groups: groups })) : ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Message, { children: i18n_1.default.sampleLoadError }))] })] }));
};
exports.Sample = Sample;
var SampleUser = function (_a) {
    var user = _a.user, world = _a.world, worldLoading = _a.worldLoading, groups = _a.groups;
    return (0, jsx_runtime_1.jsx)(ReadonlyUser_1.ReadonlyUser, { user: user, world: world, worldLoading: worldLoading });
};
var fetchUser = function () { return __awaiter(void 0, void 0, void 0, function () {
    var user, profile, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, (0, api_1.fetchUserByName)("narazaka")];
            case 1:
                user = (_a.sent());
                return [4 /*yield*/, (0, api_1.fetchProfile)(user.id)];
            case 2:
                profile = _a.sent();
                return [2 /*return*/, __assign(__assign({}, user), { profile: profile, locationInfo: (0, util_1.parseUserLocation)(user) })];
            case 3:
                e_1 = _a.sent();
                (0, sentry_1.captureException)(e_1);
                return [2 /*return*/];
            case 4: return [2 /*return*/];
        }
    });
}); };
function injectSample(user) {
    return __assign(__assign({}, user), { profile: __assign(__assign({ id: user.id }, user.profile), { profile: i18n_1.default.sampleProfilePrefix + (user.profile ? user.profile.profile : ""), tags: [{ name: i18n_1.default.sampleTagPrefix, locked: true }].concat(user.profile ? user.profile.tags || [] : []), privateMemo: i18n_1.default.samplePrivateMemo, privateMemoIsSynced: true }) });
}
